/* BORN — Displays · v8: collection limit chips · multi-step form · FAQ category filter.
   All three degrade gracefully: without JS the grid shows its default page, every form
   step is visible in one column, and every FAQ item is listed. */
(function () {
  'use strict';
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };

  /* ---------------- V · contact quality ----------------
     A hand-mirrored copy of the validation core in born-config.js — two
     bundles and no build step, so forty lines travel in both rather than
     every page loading the half-megabyte builder file. Keep the two in step
     by hand. The philosophy is the same: stop OBVIOUS garbage ("719",
     "john@gmail") at the door, and wherever a rule is uncertain, ACCEPT —
     a lost enquiry costs more than a typo'd one. No library for the phone
     on purpose: libphonenumber is half a megabyte of build tooling this
     theme does not have; NANP structure plus punctuation tolerance is the
     whole question this optional field asks. */
  function bnEmailOK(v) {
    v = String(v || '').trim();
    if (!v || v.length > 254) return false;
    var m = v.match(/^[^\s@]+@([^\s@]+)$/);   // exactly one @, no spaces anywhere
    if (!m) return false;
    var labels = m[1].split('.');
    if (labels.length < 2) return false;      // john@gmail — no TLD at all
    for (var i = 0; i < labels.length; i++) if (!labels[i]) return false; // john@gmail. · a@b..com
    var tld = labels[labels.length - 1];
    return tld.length >= 2 && /[A-Za-z]/.test(tld);
  }
  var BN_DOM_FIX = {
    'gmial.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gamil.com': 'gmail.com',
    'gmali.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmaill.com': 'gmail.com',
    'gmai.com': 'gmail.com', 'gmil.com': 'gmail.com', 'gmail.co': 'gmail.com',
    'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com', 'gmail.comm': 'gmail.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'yahoo.cm': 'yahoo.com',
    'hotmial.com': 'hotmail.com', 'hotmall.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.co': 'hotmail.com',
    'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'outlook.co': 'outlook.com',
    'iclod.com': 'icloud.com', 'icloud.co': 'icloud.com', 'aol.co': 'aol.com'
  };
  var BN_TLD_FIX = { con: 'com', cmo: 'com', ocm: 'com', vom: 'com', comm: 'com', cpm: 'com', nte: 'net', ent: 'net' };
  function bnEmailFix(v) {
    v = String(v || '').trim();
    var at = v.lastIndexOf('@');
    if (at < 1) return '';
    var dom = v.slice(at + 1).toLowerCase();
    var out = '';
    if (BN_DOM_FIX[dom]) out = v.slice(0, at + 1) + BN_DOM_FIX[dom];
    else {
      var parts = dom.split('.');
      var tld = parts[parts.length - 1];
      if (parts.length >= 2 && BN_TLD_FIX[tld]) {
        parts[parts.length - 1] = BN_TLD_FIX[tld];
        out = v.slice(0, at + 1) + parts.join('.');
      }
    }
    return (out && out.toLowerCase() !== v.toLowerCase()) ? out : '';
  }
  function bnPhoneParse(v) {
    v = String(v == null ? '' : v).trim();
    if (!v) return { bad: 'empty' };
    var extRe = /\s*(?:x|ext\.?|extension)\s*\d{1,6}$/i;
    var ext = extRe.test(v);
    var core = v.replace(extRe, '');
    if (/[A-Za-z]/.test(core)) return { bad: 'letters' };
    if (/[^\d+().\/\-\s]/.test(core)) return { bad: 'junk' };
    var digits = core.replace(/\D/g, '');
    var plus = core.charAt(0) === '+';
    if (plus && digits.charAt(0) !== '1') {
      return (digits.length >= 8 && digits.length <= 15) ? { intl: true } : { bad: 'length' };
    }
    if (!plus && /^(?:00|011)/.test(digits)) {
      var rest = digits.replace(/^00(?:1)?|^011(?:1)?/, '');
      if (/^(?:00|011)1/.test(digits)) digits = rest;
      else return (rest.length >= 8 && rest.length <= 15) ? { intl: true } : { bad: 'length' };
    }
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    if (digits.length !== 10) return { bad: 'length' };
    if (digits.charAt(0) < '2') return { bad: 'area' };
    if (digits.charAt(3) < '2') return { bad: 'exchange' };
    if (/^(\d)\1{9}$/.test(digits)) return { bad: 'repeat' };
    return { us: digits, ext: ext };
  }
  function bnPhoneOK(v) { var p = bnPhoneParse(v); return !!(p.us || p.intl); }
  function bnFmtPhoneUS(v) {
    var p = bnPhoneParse(v);
    /* A number with an extension is left exactly as typed — reformatting
       would drop the "x12", and the extension is information. */
    return (p.us && !p.ext) ? '(' + p.us.slice(0, 3) + ') ' + p.us.slice(3, 6) + '-' + p.us.slice(6) : '';
  }

  /* ---------------- G · collection limit chips ---------------- */
  function initGrid() {
    each(document.querySelectorAll('[data-bn-cgrid]'), function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var cards = root.querySelectorAll('.bn-cgrid__card');
      var chips = root.querySelectorAll('.bn-cgrid__limit');
      var count = root.querySelector('[data-cgrid-count]');
      var total = cards.length;
      function apply(n) {
        var shown = 0;
        each(cards, function (c, i) { var on = (n === 0 || i < n); c.hidden = !on; if (on) shown++; });
        each(chips, function (ch) {
          var v = parseInt(ch.dataset.limit, 10);
          var on = (v === n) || (v === 0 && n === 0);
          ch.classList.toggle('is-on', on);
          ch.setAttribute('aria-pressed', String(on));
        });
        if (count) count.textContent = 'Showing ' + shown + ' of ' + (root.dataset.total || total);
      }
      each(chips, function (ch) { ch.addEventListener('click', function () { apply(parseInt(ch.dataset.limit, 10)); }); });
      apply(parseInt(root.dataset.start || '12', 10));
    });
  }

  /* ---------------- F · multi-step form ---------------- */
  function initForm() {
    // A successful send renders the done panel and no form — whatever the
    // stash was holding has been delivered, so it goes.
    if (document.querySelector('.bn-form__done')) {
      try { sessionStorage.removeItem('bn-form-stash'); } catch (err) {}
    }
    each(document.querySelectorAll('[data-bn-form]'), function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var steps = Array.prototype.slice.call(root.querySelectorAll('.bn-form__step'));
      if (!steps.length) return;
      var names = root.querySelectorAll('.bn-form__stepname');
      var bar = root.querySelector('.bn-form__bar i');
      var back = root.querySelector('[data-form-back]');
      var next = root.querySelector('[data-form-next]');
      var send = root.querySelector('[data-form-send]');
      var review = root.querySelector('[data-form-review]');
      var at = 0;

      // Reasons are multi-select: someone can want a display AND custom work AND
      // the agency. Every chosen branch shows; the rest stay disabled so they are
      // never validated and never land in the email.
      function branchKeys() {
        return Array.prototype.map.call(
          root.querySelectorAll('input[name="contact[Reason][]"]:checked, input[name="contact[Reason]"]:checked'),
          function (i) { return i.value; }
        );
      }
      function visible(step) {
        if (step.dataset.branchStep === undefined) return true;
        var keys = branchKeys();
        return Array.prototype.some.call(root.querySelectorAll('.bn-form__branch'), function (b) {
          return keys.indexOf(b.dataset.branch) > -1;
        });
      }
      function syncBranches() {
        var keys = branchKeys();
        each(root.querySelectorAll('.bn-form__branch'), function (b) {
          var on = keys.indexOf(b.dataset.branch) > -1;
          b.classList.toggle('is-on', on);
          each(b.querySelectorAll('input, select, textarea'), function (f) { f.disabled = !on; });
        });
      }
      /* `all` widens the sweep to fields on steps that are not currently
         displayed — used at the submit boundary, where "not on screen right
         now" must not mean "not checked". Disabled fields (unchosen
         branches) stay excluded either way; that is what keeps unpicked
         branches out of validation AND out of the email. */
      function fieldsIn(step, all) {
        return Array.prototype.slice.call(step.querySelectorAll('[data-required]')).filter(function (f) {
          return !f.disabled && (all || f.offsetParent !== null);
        });
      }
      /* is-bad paints the field; aria-invalid + aria-describedby tell a
         screen reader the same thing the red tells everyone else. Name and
         email carry their err span in the template already; the phone —
         optional, so it never had one — gets its line built here the first
         time it is needed, which keeps the template untouched. */
      function markBad(f, bad) {
        var wrap = f.closest('.bn-field') || f.closest('.bn-form__group');
        if (wrap) wrap.classList.toggle('is-bad', bad);
        if (!f.setAttribute) return;
        if (bad) f.setAttribute('aria-invalid', 'true'); else f.removeAttribute('aria-invalid');
        var err = wrap && wrap.querySelector('.bn-field__err');
        if (!err && bad && wrap && f.type === 'tel') {
          err = document.createElement('span');
          err.className = 'bn-field__err';
          err.textContent = 'Please enter a complete phone number.';
          wrap.appendChild(err);
        }
        if (err) {
          if (!err.id) err.id = (f.id || 'bn-f') + '-err';
          if (bad) f.setAttribute('aria-describedby', err.id); else f.removeAttribute('aria-describedby');
        }
      }
      /* The "Did you mean gmail.com?" line — a suggestion, never a block and
         never an auto-correct. A real button, so keyboard and screen reader
         users can take the offer; the customer stays in control either way. */
      function fixLine(f, suggested) {
        var wrap = f.closest('.bn-field');
        if (!wrap) return;
        var n = wrap.querySelector('.bn-field__fix');
        if (!suggested) { if (n) n.parentNode.removeChild(n); return; }
        if (!n) { n = document.createElement('span'); n.className = 'bn-field__fix'; wrap.appendChild(n); }
        n.innerHTML = '';
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bn-field__fixBtn';
        b.textContent = 'Did you mean ' + suggested + '?';
        b.addEventListener('click', function () {
          f.value = suggested;
          markBad(f, false);
          if (n.parentNode) n.parentNode.removeChild(n);
          f.focus();
        });
        n.appendChild(b);
      }
      function validate(step, all) {
        var ok = true, first = null;
        fieldsIn(step, all).forEach(function (f) {
          var val = (f.value || '').trim();
          var good = !!val;
          if (good && f.type === 'email') good = bnEmailOK(val);
          markBad(f, !good);
          if (!good) { ok = false; if (!first) first = f; }
        });
        /* The optional phone: blank is always fine — the field is not
           required and must not become so — but a filled number that is
           obviously not one would bounce the reply call, so it blocks with
           the same friendly line the builder uses. */
        each(step.querySelectorAll('input[type="tel"]'), function (f) {
          if (f.disabled || (!all && f.offsetParent === null)) return;
          var val = (f.value || '').trim();
          var good = !val || bnPhoneOK(val);
          markBad(f, !good);
          if (!good) { ok = false; if (!first) first = f; }
        });
        // radio groups flagged as required
        each(step.querySelectorAll('[data-required-group]'), function (g) {
          var picked = g.querySelector('input:checked');
          g.classList.toggle('is-bad', !picked);
          if (!picked) { ok = false; if (!first) first = g.querySelector('input'); }
        });
        if (first && first.focus) first.focus();
        return ok;
      }
      function paint() {
        steps.forEach(function (s, i) { s.classList.toggle('is-on', i === at); });
        each(names, function (n, i) {
          n.classList.toggle('is-on', i === at);
          n.classList.toggle('is-done', i < at);
        });
        if (bar) bar.style.width = Math.round(((at + 1) / steps.length) * 100) + '%';
        if (back) back.hidden = at === 0;
        var last = at === steps.length - 1;
        if (next) next.hidden = last;
        if (send) send.hidden = !last;
        if (last) buildReview();
        var top = root.getBoundingClientRect().top + window.scrollY - 110;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
      function go(dir) {
        if (dir > 0 && !validate(steps[at])) return;
        var i = at;
        do { i += dir; } while (steps[i] && !visible(steps[i]));
        if (i < 0 || i >= steps.length) return;
        at = i;
        paint();
      }
      function label(el) {
        var f = el.closest('.bn-field');
        var l = f && f.querySelector('label');
        return l ? l.textContent.replace('*', '').trim() : (el.name || '').replace(/^contact\[|\]$/g, '');
      }
      /* One walk of the answered fields, shared by the review screen and by
         composeBody() below — the two must agree about what was said. */
      function collectRows() {
        var seen = {};
        each(root.querySelectorAll('input, select, textarea'), function (f) {
          if (f.disabled || f.type === 'hidden' || !f.name) return;
          var v = '';
          if (f.type === 'radio' || f.type === 'checkbox') { if (!f.checked) return; v = (f.dataset.label || f.value); }
          else v = (f.value || '').trim();
          if (!v) return;
          var key = f.dataset.review || label(f) || f.name;
          seen[key] = seen[key] ? seen[key] + ', ' + v : v;
        });
        return seen;
      }
      function buildReview() {
        if (!review) return;
        review.innerHTML = '';
        var seen = collectRows();
        Object.keys(seen).forEach(function (k) {
          var row = document.createElement('div');
          row.className = 'bn-form__rrow';
          var kk = document.createElement('span'); kk.className = 'bn-form__rkey'; kk.textContent = k;
          var vv = document.createElement('span'); vv.className = 'bn-form__rval'; vv.textContent = seen[k];
          row.appendChild(kk); row.appendChild(vv);
          review.appendChild(row);
        });
        if (!review.children.length) {
          var p = document.createElement('p'); p.className = 'bn-form__hint';
          p.textContent = 'Nothing to review yet — step back and add a few details.';
          review.appendChild(p);
        }
      }
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
      if (back) back.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
      each(root.querySelectorAll('[data-form-goto]'), function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); at = Math.max(0, Math.min(steps.length - 1, parseInt(b.dataset.formGoto, 10))); paint(); });
      });
      each(root.querySelectorAll('input[name="contact[Reason][]"], input[name="contact[Reason]"]'), function (r) {
        r.addEventListener('change', function () { syncBranches(); });
      });
      // clear the error state as soon as someone fixes a field, and any stale
      // "did you mean" the moment the address moves at all (blur re-offers it)
      root.addEventListener('input', function (e) {
        if (e.target.matches('[data-required], input[type="tel"]')) markBad(e.target, false);
        if (e.target.matches('input[type="email"]')) fixLine(e.target, '');
      });
      root.addEventListener('change', function (e) {
        var g = e.target.closest('[data-required-group]');
        if (g && g.querySelector('input:checked')) g.classList.remove('is-bad');
      });
      /* Validate when the field is LEFT, never while someone is mid-typing —
         three digits into a phone number is not wrong, it is busy. Empty
         fields are deliberately left alone here: "you missed this" is
         Continue's and Send's line, not something to bark at a person who
         tabbed through. A recognisably US number gets tidied to
         (719) 555-1234; the value still travels in this same field, so
         nothing about the submission changes shape. */
      root.addEventListener('focusout', function (e) {
        var f = e.target;
        if (!f || !f.matches || !f.matches('input[type="email"], input[type="tel"]')) return;
        var val = (f.value || '').trim();
        if (!val) { if (f.type === 'email') fixLine(f, ''); return; }
        if (f.type === 'tel') {
          var good = bnPhoneOK(val);
          markBad(f, !good);
          if (good) { var pretty = bnFmtPhoneUS(val); if (pretty && pretty !== val) f.value = pretty; }
          return;
        }
        markBad(f, !bnEmailOK(val));
        fixLine(f, bnEmailFix(val));   // gmail.con is "valid" — the nudge is the only net that catches it
      });
      /* =================================================================
         THE SUBMIT BOUNDARY. The {% form %} element is the PARENT of this
         root (the submit-handler block below has never found it — see the
         comment there), and Shopify's storefront captcha script watches
         submit at the document level in the capture phase, so a handler on
         the submit EVENT is already too late to stop anything (the builder
         learned this the hard way). The reliable gate therefore sits on
         the two ways a submission can start — the Send button's click and
         the Enter key — where preventDefault() still means no submit event
         ever exists and the captcha machinery never engages with bad data.
         ================================================================= */
      var formEl = root.closest('form');

      function validateAll() {
        syncBranches();
        for (var i = 0; i < steps.length; i++) {
          if (!visible(steps[i])) continue;
          if (!validate(steps[i], true)) return i;
        }
        return -1;
      }

      /* SHOPIFY GETS A body. Every answer in this form travels as a custom
         contact[...] field; nothing filled the reserved contact[body], and
         a submission whose message area came through blank is exactly the
         shape of the live "That didn't send — is invalid" rejection. So
         the moment a valid form is sent, a hidden contact[body] is written
         with the same readable summary the review screen shows (the typed
         message, when there is one, rides at the top via its own row).
         Every labelled field still posts untouched — the notification
         email keeps its per-field rows and gains a readable digest. */
      function composeBody() {
        if (!formEl) return;
        var b = formEl.querySelector('input[name="contact[body]"]');
        if (!b) {
          b = document.createElement('input');
          b.type = 'hidden';
          b.name = 'contact[body]';
          formEl.appendChild(b);
        }
        var seen = collectRows();
        var lines = Object.keys(seen).map(function (k) { return k + ': ' + seen[k]; });
        b.value = lines.length ? lines.join('\n') : 'New enquiry from the contact form.';
      }

      /* WHAT WAS TYPED, KEPT. Two copies, cheap and local: the values ride
         sessionStorage from the moment Send is pressed, and Shopify itself
         echoes every contact[...] field back in the query string when a
         rejected POST bounces. Restore prefers the echo (it is what the
         server actually saw) and falls back to the stash. */
      var STASH_KEY = 'bn-form-stash';
      function stash() {
        try {
          var m = {};
          each(root.querySelectorAll('input, select, textarea'), function (f) {
            if (!f.name || f.type === 'hidden') return;
            if (f.type === 'checkbox' || f.type === 'radio') {
              if (f.checked) (m[f.name] = m[f.name] || []).push(f.value);
              else if (!(f.name in m)) m[f.name] = m[f.name] || [];
            } else (m[f.name] = m[f.name] || []).push(f.value);
          });
          sessionStorage.setItem(STASH_KEY, JSON.stringify(m));
        } catch (err) {}
      }
      /* The bounce comes back in one of two spellings, and both are seen in
         the wild on this store: individual contact[X]=v params, or a single
         `contact` param holding the whole hash serialised Ruby-style —
         {"Show date" => "2026-10-15", "Reason" => ["…"]}. The latter is one
         ` => ` swap away from JSON; anything that will not parse is simply
         ignored and the sessionStorage stash takes over. Array-valued keys
         are filed under both contact[K][] and contact[K], because the
         section names its checkbox groups both ways. */
      function echoedValues() {
        var out = null;
        try {
          var qs = new URLSearchParams(location.search);
          qs.forEach(function (v, k) {
            if (k.indexOf('contact[') === 0) { out = out || {}; (out[k] = out[k] || []).push(v); }
            else if (k === 'contact' && v.charAt(0) === '{') {
              try {
                var obj = JSON.parse(v.replace(/"\s*=>\s*/g, '": '));
                Object.keys(obj).forEach(function (key) {
                  var vals = Array.isArray(obj[key]) ? obj[key] : [obj[key]];
                  vals = vals.map(function (x) { return String(x == null ? '' : x); });
                  out = out || {};
                  out['contact[' + key + ']'] = vals;
                  out['contact[' + key + '][]'] = vals;
                });
              } catch (err2) {}
            }
          });
        } catch (err) {}
        return out;
      }
      function restoreFrom(m) {
        each(root.querySelectorAll('input, select, textarea'), function (f) {
          if (!f.name || f.type === 'hidden' || !(f.name in m)) return;
          var vals = m[f.name] || [];
          var before = (f.type === 'checkbox' || f.type === 'radio') ? f.checked : f.value;
          if (f.type === 'checkbox' || f.type === 'radio') f.checked = vals.indexOf(f.value) > -1;
          else if (f.tagName === 'SELECT') { if (vals.length && vals[0]) f.value = vals[0]; } // a select always "has" a value, so no blank-check
          else if (!f.value && vals.length && vals[0]) f.value = vals[0]; // Liquid re-fills name/email/body itself; this covers the rest
          var after = (f.type === 'checkbox' || f.type === 'radio') ? f.checked : f.value;
          /* Announce what changed the way typing would — the calendar's
             field text, the branch sync and anything else listening must
             not be left describing the pre-restore emptiness. */
          if (after !== before) {
            try { f.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) {}
          }
        });
      }

      if (send) send.addEventListener('click', function (e) {
        var bad = validateAll();
        if (bad > -1) {
          /* stopImmediatePropagation as well: a prevented click must also
             never reach any other click listener that could start a
             submission on our behalf. */
          e.preventDefault();
          e.stopImmediatePropagation();
          at = bad;
          paint();
          return;
        }
        composeBody();
        stash();
      }, true);

      /* Enter used to fall through to the browser's implicit submission —
         a native POST that no step had validated. Now it does what the
         builder's Enter does: acts as Continue mid-form, acts as Send (via
         the guarded click above) on the review step. */
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var t = e.target;
        if (!t || t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.tagName === 'A' || t.tagName === 'SELECT') return;
        e.preventDefault();
        if (at === steps.length - 1) { if (send) send.click(); }
        else if (next) next.click();
      });

      /* A REJECTED POST IS NO LONGER A COLD RESET. Shopify re-renders the
         page with form.errors and (on this section) bounces the payload
         back in the query string. Put the person back where the problem
         is, with everything they typed, and say so in words — Shopify's
         raw reason stays in small print because it is the one clue a
         support screenshot can carry. */
      var errBox = root.querySelector('.bn-form__errors');
      if (errBox) {
        var echoed = echoedValues();
        if (!echoed) { try { echoed = JSON.parse(sessionStorage.getItem(STASH_KEY) || 'null'); } catch (err) {} }
        var restored = false;
        if (echoed) { restoreFrom(echoed); restored = true; }
        syncBranches();
        var raw = '';
        each(errBox.querySelectorAll('li'), function (li) {
          var txt = li.textContent.replace(/\s+/g, ' ').trim();
          if (txt) raw += (raw ? ' · ' : '') + txt;
        });
        var head = errBox.querySelector('strong');
        errBox.innerHTML = '';
        if (!head) { head = document.createElement('strong'); head.textContent = 'That didn’t send.'; }
        errBox.appendChild(head);
        var p = document.createElement('p');
        p.textContent = restored
          ? ' Nothing you typed was lost — it is all still here. Check the highlighted field below, then send it again.'
          : ' Please look over your answers and send it again.';
        errBox.appendChild(p);
        if (raw) {
          var s = document.createElement('small');
          s.textContent = '(' + raw + ')';
          errBox.appendChild(s);
        }
        var badAt = validateAll();
        at = badAt > -1 ? badAt : steps.length - 1;   // straight to the problem, or to Review ready to resend
      }

      /* Kept for the record: root IS inside the form, so this lookup finds
         nothing and the block below has never run. Left exactly as it was
         — binding it now would set novalidate and change how the native
         form behaves, and the click/keydown gates above already stand in
         front of every road into a submission. */
      var form = root.querySelector('form');
      if (form) {
        form.setAttribute('novalidate', 'novalidate');
        form.addEventListener('submit', function (e) {
          syncBranches();
          for (var i = 0; i < steps.length; i++) {
            if (!visible(steps[i])) continue;
            if (!validate(steps[i])) { e.preventDefault(); at = i; paint(); return; }
          }
        });
      }
      syncBranches();
      paint();
    });
  }

  /* ---------------- Q · FAQ category chips (one topic at a time) ---------------- */
  function initFaqCats() {
    each(document.querySelectorAll('[data-bn-faqc]'), function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var chips = root.querySelectorAll('.bn-faqc__cat');
      var items = root.querySelectorAll('.bn-faqc__item');
      var count = root.querySelector('[data-faqc-count]');
      var empty = root.querySelector('[data-faqc-empty]');
      /* Seed from whichever chip Liquid marked is-on, so the default tab is set in
         the template rather than hardcoded here. With a "Most asked" chip present
         that is the landing state; without one it falls back to Everything. */
      var seed = root.querySelector('.bn-faqc__cat.is-on');
      var picked = (seed && seed.dataset.cat) ? [seed.dataset.cat] : [];   // at most one topic — chips behave as tabs
      function apply() {
        var shown = 0;
        each(items, function (it) {
          var cats = (it.dataset.cats || '').split(',');
          var on = !picked.length || picked.some(function (p) { return cats.indexOf(p) > -1; });
          it.hidden = !on;
          if (!on) it.open = false;
          if (on) shown++;
        });
        each(chips, function (ch) {
          var v = ch.dataset.cat;
          var on = v === '' ? !picked.length : picked.indexOf(v) > -1;
          ch.classList.toggle('is-on', on);
          ch.setAttribute('aria-pressed', String(on));
        });
        if (count) count.textContent = shown + (shown === 1 ? ' question' : ' questions');
        if (empty) empty.hidden = shown > 0;
      }
      each(chips, function (ch) {
        ch.addEventListener('click', function () {
          var v = ch.dataset.cat;
          // one at a time: picking a topic replaces the last, and tapping the
          // active one (or "Everything") clears back to the full list
          picked = (v === '' || picked[0] === v) ? [] : [v];
          apply();
        });
      });
      apply();
    });
  }

  /* ---------------- C · the calendar, ported from the builder ----------
     The booth builder's show-date control — a field-sized button with the
     month grid folded underneath — brought to the enquiry form's two date
     questions so the whole site asks for a date in one voice. Class names
     are bnf-cal__* (not the builder's bn-cal__*) because born-all.css and
     born-config.css ride the same pages and the two controls must never
     restyle each other. The native type=date input STAYS in the form as
     the value carrier: same name, same ISO yyyy-mm-dd it always posted —
     it is only hidden by CSS once the control mounts, so without JS the
     browser's own picker still works and nothing is lost. */
  var CAL_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  var CAL_DOWS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var CAL_DOWS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var CAL_MONTHS_OUT = 36;   // same bookable horizon as the builder
  function calDaysIn(y, m) { return new Date(y, m + 1, 0).getDate(); }
  function calISO(y, m, d) { return y + '-' + (m + 1 < 10 ? '0' : '') + (m + 1) + '-' + (d < 10 ? '0' : '') + d; }
  function calTodayISO() { var d = new Date(); return calISO(d.getFullYear(), d.getMonth(), d.getDate()); }

  function initCal() {
    each(document.querySelectorAll('[data-bn-form] input[type="date"]'), function (inp) {
      if (inp.dataset.calBound) return; inp.dataset.calBound = '1';

      var open = false;
      var view = null;
      var now = new Date();
      var minY = now.getFullYear(), minM = now.getMonth();
      var maxTotal = minY * 12 + minM + CAL_MONTHS_OUT;

      function fieldText() {
        if (!inp.value) return 'Select a date';
        var p = inp.value.split('-');
        var dt = new Date(+p[0], +p[1] - 1, +p[2]);
        return CAL_DOWS_LONG[dt.getDay()].slice(0, 3) + ', ' + CAL_MONTHS[dt.getMonth()].slice(0, 3) +
          ' ' + dt.getDate() + ', ' + dt.getFullYear();
      }

      /* Same clothes as the builder's field: glyph, text, chevron. */
      var ctl = document.createElement('div');
      ctl.className = 'bnf-cal__ctl';
      ctl.innerHTML =
        '<button type="button" class="bnf-cal__fieldBtn" data-bnf-toggle aria-expanded="false" aria-haspopup="true">' +
        '<svg class="bnf-cal__fieldGlyph" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">' +
        '<rect x="1.8" y="2.8" width="12.4" height="11.4" rx="2"/><path d="M1.8 6.2h12.4M5 1.4v2.8M11 1.4v2.8" stroke-linecap="round"/></svg>' +
        '<span class="bnf-cal__fieldText" data-bnf-fieldtext></span>' +
        '<svg class="bnf-cal__fieldChev" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m3 6 5 5 5-5"/></svg>' +
        '</button>' +
        '<div class="bnf-cal__pop" data-bnf-pop><div class="bnf-cal__popIn"><div class="bnf-cal" data-bnf-grid></div></div></div>';
      inp.parentNode.insertBefore(ctl, inp);
      inp.classList.add('bnf-cal__native');   // display:none — the input keeps its name and value, the button does the talking

      var btn = ctl.querySelector('[data-bnf-toggle]');
      var txt = ctl.querySelector('[data-bnf-fieldtext]');
      var pop = ctl.querySelector('[data-bnf-pop]');
      var grid = ctl.querySelector('[data-bnf-grid]');

      // the label already on the field names the button too
      var lab = inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null;
      if (lab) {
        if (!lab.id) lab.id = inp.id + '-lbl';
        btn.setAttribute('aria-labelledby', lab.id);
      }

      function syncOpen() {
        if (open) pop.setAttribute('data-on', ''); else pop.removeAttribute('data-on');
        btn.setAttribute('aria-expanded', String(open));
      }
      function syncField() {
        txt.textContent = fieldText();
        btn.classList.toggle('is-set', !!inp.value);
      }

      function paintCal() {
        var y = view.y, m = view.m;
        var total = y * 12 + m;
        var atMin = total <= minY * 12 + minM;
        var atMax = total >= maxTotal;
        var first = new Date(y, m, 1).getDay();
        var n = calDaysIn(y, m);
        var tISO = calTodayISO();

        var h = '<div class="bnf-cal__head">' +
          '<button type="button" class="bnf-cal__nav" data-bnf-nav="-1" aria-label="Previous month"' + (atMin ? ' disabled' : '') + '>' +
          '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M7.5 2.5 4 6l3.5 3.5"/></svg></button>' +
          '<span class="bnf-cal__title">' + CAL_MONTHS[m] + ' ' + y + '</span>' +
          '<button type="button" class="bnf-cal__nav" data-bnf-nav="1" aria-label="Next month"' + (atMax ? ' disabled' : '') + '>' +
          '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 2.5 8 6l-3.5 3.5"/></svg></button>' +
          '</div>';

        var dow = '<div class="bnf-cal__dow" aria-hidden="true">';
        for (var w = 0; w < 7; w++) dow += '<span>' + CAL_DOWS[w] + '</span>';
        dow += '</div>';

        // roving tabindex, exactly as in the builder: the selected day when
        // it is on screen, else today, else the first pickable day
        var selHere = 0;
        if (inp.value) {
          var q = inp.value.split('-');
          if (+q[0] === y && +q[1] - 1 === m) selHere = +q[2];
        }
        var focusDay = 0;
        for (var d0 = 1; d0 <= n && !focusDay; d0++) if (calISO(y, m, d0) >= tISO) focusDay = d0;
        if (selHere) focusDay = selHere;
        else if (y === now.getFullYear() && m === now.getMonth()) focusDay = now.getDate();

        var g = '<div class="bnf-cal__grid" role="grid" aria-label="' + CAL_MONTHS[m] + ' ' + y + '">';
        for (var b = 0; b < first; b++) g += '<span class="bnf-cal__blank" aria-hidden="true"></span>';
        for (var d = 1; d <= n; d++) {
          var di = calISO(y, m, d);
          var past = di < tISO;
          var today = di === tISO;
          var sel = d === selHere;
          g += '<button type="button" class="bnf-cal__day' +
            (today ? ' is-today' : '') + (sel ? ' is-sel' : '') + '"' +
            ' data-bnf-day="' + d + '"' + (past ? ' disabled' : '') +
            ' tabindex="' + (d === focusDay ? '0' : '-1') + '"' +
            ' aria-pressed="' + sel + '"' +
            ' aria-label="' + CAL_MONTHS[m] + ' ' + d + ', ' + y + (today ? ' (today)' : '') + '">' +
            d + '</button>';
        }
        g += '</div>';
        grid.innerHTML = h + dow + g;
      }

      function pick(d) {
        var di = calISO(view.y, view.m, d);
        if (di < calTodayISO()) return;
        inp.value = di;
        /* Announce it the way typing would, so the review screen, the
           stash and the body digest all hear about the date. */
        try {
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (err) {}
        paintCal();
        open = false; syncOpen(); syncField();
        btn.focus();
      }

      btn.addEventListener('click', function () {
        open = !open;
        if (open) {
          if (inp.value) { var fp = inp.value.split('-'); view = { y: +fp[0], m: +fp[1] - 1 }; }
          else view = { y: now.getFullYear(), m: now.getMonth() };
          paintCal();
        }
        syncOpen();
        if (open) {
          var f0 = grid.querySelector('.bnf-cal__day[tabindex="0"]');
          if (f0) f0.focus();
        }
      });

      grid.addEventListener('click', function (e) {
        var nav = e.target.closest('[data-bnf-nav]');
        if (nav && !nav.disabled) {
          var t = view.y * 12 + view.m + (+nav.getAttribute('data-bnf-nav'));
          t = Math.max(minY * 12 + minM, Math.min(maxTotal, t));
          view = { y: Math.floor(t / 12), m: t % 12 };
          paintCal();
          return;
        }
        var day = e.target.closest('[data-bnf-day]');
        if (day && !day.disabled) pick(+day.getAttribute('data-bnf-day'));
      });

      /* Keyboard, verbatim from the builder: arrows a day/week, PageUp/Down
         a month, Escape folds the grid, Enter/Space pick (native button). */
      grid.addEventListener('keydown', function (e) {
        var day = e.target.closest('[data-bnf-day]');
        var jump = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
        if (e.key === 'PageUp' || e.key === 'PageDown') {
          e.preventDefault();
          var nav = grid.querySelector('[data-bnf-nav="' + (e.key === 'PageUp' ? -1 : 1) + '"]');
          if (nav && !nav.disabled) nav.click();
          var f = grid.querySelector('.bnf-cal__day[tabindex="0"]');
          if (f) f.focus();
          return;
        }
        if (e.key === 'Escape') {
          e.stopPropagation();
          open = false; syncOpen();
          btn.focus();
          return;
        }
        if (!day || !jump) return;
        e.preventDefault();
        var nxt = +day.getAttribute('data-bnf-day') + jump;
        var target = grid.querySelector('[data-bnf-day="' + nxt + '"]');
        if (target && !target.disabled) {
          each(grid.querySelectorAll('.bnf-cal__day'), function (x) { x.setAttribute('tabindex', '-1'); });
          target.setAttribute('tabindex', '0');
          target.focus();
        }
      });

      syncOpen(); syncField();

      /* A rejected POST restores the input's value AFTER this mounts (the
         recovery block runs in the same boot) — keep the field text honest
         whenever the value changes underneath us. */
      inp.addEventListener('change', syncField);
    });
  }

  function boot() { initGrid(); initForm(); initCal(); initFaqCats(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
